import { render, staticRenderFns } from "./IconComputer.vue?vue&type=template&id=99ac8278&"
import script from "./IconComputer.vue?vue&type=script&lang=js&"
export * from "./IconComputer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports